import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import {
  MailOutlined,
  TeamOutlined,
  UserOutlined,
  DashboardOutlined,
  StopOutlined
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import './MarketingLayout.css';

const { Sider, Content } = Layout;

const MarketingLayout: React.FC = () => {
  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: <NavLink to="/marketing/dashboard">Dashboard</NavLink>,
    },
    {
      key: 'contacts',
      icon: <UserOutlined />,
      label: <NavLink to="/marketing/contacts">Contacts</NavLink>,
    },
    {
      key: 'audiences',
      icon: <TeamOutlined />,
      label: <NavLink to="/marketing/audiences">Audiences</NavLink>,
    },
    {
      key: 'campaigns',
      icon: <MailOutlined />,
      label: <NavLink to="/marketing/campaigns">Campaigns</NavLink>,
    },
    {
      key: 'unsubscribers',
      icon: <StopOutlined />,
      label: <NavLink to="/marketing/unsubscribers">Unsubscribers</NavLink>,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider theme="light" width={200}>
        <div className="marketing-menu-header">
          <MailOutlined style={{ marginRight: 8 }} />
          Marketing
        </div>
        <Menu
          mode="inline"
          defaultSelectedKeys={['dashboard']}
          items={menuItems}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <Layout>
        <Content style={{ padding: 24, background: '#fff' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MarketingLayout;